<template>
  <section id="slotmachine">
    <article class="slot">
      <ul class="roster" ref="roller">
        <li class="name" v-for="person in roster" :key="person.id">{{person.name}}</li>
      </ul>
    </article>
  </section>
</template>

<script>
import anime from 'animejs';

export default {
    name: 'Slotmachine',
    props: {
      roster: Array
    },
    data(){
      return {
        selected: null,
        spin: false,
        toBeExcluded: null
      }
    },
    methods: { 
      async trigger(){

        await this.$store.commit('excludeName', this.toBeExcluded);

        if(this.roster.length){

          let randomIndex = Math.floor(Math.random()*this.roster.length);
          let rollerHeight = this.$refs.roller.offsetHeight;
          let elHeight = (rollerHeight/this.roster.length);
          let length = (randomIndex*elHeight)+elHeight;

          this.toBeExcluded = this.roster[randomIndex].id;
          let spin = await anime({
            targets: this.$refs.roller,
            translateY: [
              { value: `0`, duration: 1, easing: 'linear' },
              { value: `-${rollerHeight}`, duration: rollerHeight, easing: 'linear' },
              { value: `-${elHeight}`, duration: 1, easing: 'linear' },
              { value: `-${length}`, duration: length, easing: 'linear' }
            ]
          });

          spin.finished.then(async () => {
            await this.$store.commit('updatePicked', this.roster[randomIndex]);
          })

        } else {
          this.toBeExcluded = null // reset excluder
        }
      }
    }
}
</script>

<style lang="scss">
@import './../../scss/variables';

#slotmachine {
  height: 100vh;
  width: 100vw;
  @include center;
  flex-direction: column;
  padding: 1rem;
  overflow: hidden;

  .slot {
    width: 100%;
    max-width: 40rem;
    margin: 4rem;
    height: 4rem;
    overflow: hidden;

    .roster {
      margin-top: 4rem;
      display: flex;
      flex-direction: column;

      .name {
        font-size: $font-big;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4rem;
        width: 100%;

        &.selected {
          color: white;
        }
      }
    }
  }
}
</style>